import { useTranslation } from 'react-i18next';
import { addMonths, formatMes, todayISO } from '@/lib/format';
import type { Language } from '@/i18n';
import { Icon } from './ui/Icon';

interface Props {
  mes: string;
  onChange: (mes: string) => void;
  scope?: string;
}

/** Month stepper. Never walks past the current month — the future has no hours. */
export function MonthNavigator({ mes, onChange, scope }: Props) {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage ?? 'pt') as Language;
  const mesAtual = todayISO().slice(0, 7);
  const podeAvancar = mes < mesAtual;

  return (
    <div className="flex items-center justify-between rounded-2xl border border-conduril-border bg-white p-2">
      <button
        type="button"
        aria-label="previous month"
        onClick={() => onChange(addMonths(mes, -1))}
        className="grid h-[34px] w-[34px] place-items-center rounded-xl border border-conduril-border bg-[#fbfbfd] text-conduril"
      >
        <Icon name="chevron_left" className="text-[18px]" />
      </button>
      <div className="text-center">
        <div className="text-[15px] font-semibold leading-none text-conduril-ink">
          {formatMes(mes, lang)}
        </div>
        {scope && (
          <div className="num mt-1 text-[10px] uppercase tracking-widest text-conduril-muted">
            {scope}
          </div>
        )}
      </div>
      <button
        type="button"
        aria-label="next month"
        disabled={!podeAvancar}
        onClick={() => onChange(addMonths(mes, 1))}
        className="grid h-[34px] w-[34px] place-items-center rounded-xl border border-conduril-border
                   bg-[#fbfbfd] text-conduril disabled:opacity-35"
      >
        <Icon name="chevron_right" className="text-[18px]" />
      </button>
    </div>
  );
}
